import { Component, OnInit } from '@angular/core';
import { TokenStorage } from '../../../../storages/token.storage';
import { Router } from '@angular/router';
import { NavbarInfoService } from '../../services/navbar-info.service';

declare var $: any;

@Component({
  selector: 'app-home-navigate-bar',
  templateUrl: './home-navigate-bar.component.html',
  styleUrls: ['./home-navigate-bar.component.sass']
})
export class HomeNavigateBarComponent implements OnInit {

  modelInfo: any;

  constructor(private token: TokenStorage, private router: Router, private info: NavbarInfoService) {
    this.modelInfo = {};
  }

  ngOnInit() {
    this.info.get().subscribe(info => {
      if (info != null) {
        this.modelInfo.name = info["name"];
      }
    });
  }

  logout(): void {
    this.token.signOut();
  }

  fileExportExample(){
    
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-navigate-bar/home-navigate-bar.component.ts